module.exports = __webpack_public_path__ + "img/donations_banner.ac0bc9ea.png";